<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title">Solicitud de servicio</span>
            <button
                mat-icon-button
                aria-label="Close dialog"
                (click)="dialogRef.close()"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <form
            class="form"
            autocomplete="off"
            [formGroup]="formSolicitarServicio"
        >
            <mat-label class="center">
                A continuación se generará la siguiente solicitud de servicio:
                <p>
                    <strong> {{ data.descripcion }} </strong
                    ><span *ngIf="data.cantidad"
                        >({{ data.cantidad }}
                        {{ data.unidadMedida.descripcion }})</span
                    >
                    <span *ngIf="data.cantidad && data.tiempo">
                        &nbsp;x&nbsp;
                    </span>
                    <span *ngIf="data.tiempo"
                        >({{ data.tiempo }}
                        {{ data.unidadTiempo?.descripcion }})</span
                    >
                </p>
            </mat-label>
            <mat-form-field class="full-width mt-16">
                <mat-label class="center"
                    >N° de ticket (Si no posee un nro. de ticket en estos
                    momentos, podrá ingresarlo mas tarde)
                </mat-label>
                <input matInput type="text" formControlName="ticket" />
                <mat-hint>Nro. de ticket de su sistema de seguimiento</mat-hint>
                <mat-error *ngIf="ticket.hasError('maxlength')">
                    El numero de ticket no puede ser mayor a 20 caracteres
                </mat-error>
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cerrar</button>
        <button
            mat-raised-button
            color="accent"
            [mat-dialog-close]="formSolicitarServicio.value"
            [disabled]="!formSolicitarServicio.valid"
        >
            Solicitar servicio
        </button>
    </mat-dialog-actions>
</div>
